import 'react-quill/dist/quill.snow.css';
import './InputRichText.scss';

import { FilledInput, FormControl } from '@mui/material';
import classNames from 'classnames';
import React, { forwardRef, useMemo, useRef, useState } from 'react';
import ReactQuill, { Value } from 'react-quill';

import { InputProps, ValueType } from './InputWrapper';

type InputRichProps<T extends ValueType = string> = {
  initialValue?: Value;
  placeholder?: string;
} & InputProps<T>;

// @ts-ignore
const InputQuill = forwardRef<any>((props: InputRichProps, ref) => {
  const [valueState, setValue] = useState<Value>(props.value?.toString() || '');
  const refQuill = useRef();
  const imageHandler = () => {
    if (!refQuill) return;

    // @ts-ignore
    const editor = (refQuill?.current as ReactQuill).getEditor();
    const range = editor.getSelection();
    const value = prompt('Please enter the image URL');

    if (value && range) {
      editor.insertEmbed(range.index, 'image', value, 'user');
    }
  };
  const modules = useMemo(
    () => ({
      toolbar: {
        handlers: {
          image: imageHandler,
        },
      },
    }),
    [],
  );
  const enhancedOnChange = (value: Value) => {
    setValue(value);
    if (props.onChange) {
      return props.onChange({
        type: 'change',
        target: { value: value.toString() },
      });
    }
  };
  return (
    <ReactQuill
      {...props}
      // @ts-ignore
      ref={refQuill}
      theme="snow"
      readOnly={props.disabled}
      className={classNames({ disabled: props.disabled })}
      onChange={enhancedOnChange}
      value={valueState}
      defaultValue={valueState}
      name={props.name}
    />
  );
});

export const InputRich = forwardRef((richProps: InputRichProps, ref) => {
  return (
    <FormControl className={'input-rich'}>
      <FilledInput
        key={richProps.name}
        name={richProps.name}
        {...richProps}
        // @ts-ignore
        refInput={ref}
        components={{
          // eslint-disable-next-line react/display-name
          Input: InputQuill,
        }}
      />
    </FormControl>
  );
});

InputRich.displayName = 'InputRich';
InputQuill.displayName = 'InputQuill';
